import { useEffect, useState } from 'react';
import type { Accounts, Product } from '@accounts/domain';
import type { Refusal } from '@accounts/transport';
import { useRead } from '@accounts/ui';

/** This installation's products, by which an organization's page names them */
export interface Products {
	/** Undefined until they are first read */
	list?: Product[];
	/** Why they were not read */
	unread?: Refusal;
	/** Reads them again: true when Beyond Accounts answered */
	run: () => Promise<boolean>;
	/** Beyond Accounts did not answer and nothing was read: their places say "Not available right now" */
	unavailable: boolean;
}

/**
 * The products an organization's page names: what each role may do in each product, in the role dialog,
 * and what each product holds, before deleting the organization or removing a member. Their read is one
 * of the page's: while a place that names them is open it joins the page's one notice (D163), and the
 * place says "Not available right now" rather than naming a product by its identifier.
 */
export function useProducts(accounts: Accounts): Products {
	const [list, setList] = useState<Product[]>();
	const { unread, run } = useRead(async () => setList((await accounts.providers()).products));

	useEffect(() => {
		void run();
	}, [run, accounts]);

	return { list, unread, run, unavailable: Boolean(unread?.unreachable) && !list };
}
